import DialogInfo from '~/components/dialog/info/DialogInfo.vue';
import DialogError from '~/components/dialog/error/DialogError.vue';
import DialogList from '~/components/dialog/list/DialogList.vue';

interface ItemParam {
  label: string;
  click?: () => void | Promise<void>;
  hasDiamond?: boolean;
}

export const useLibraryDialogAdd = (
  libraryBooks: LibraryBookSchema[],
  asMainContent: boolean = false,
  autoRedirect: boolean = false
) => {
  const loading = ref<boolean>(false);

  const dialog = useDialogStore();

  const { t } = useI18n();

  const { getContentPathFromId } = useContentsHelper();

  const libraryBooksSetAsMainContent = useLibraryBooksSetAsMainContent();

  const select = async (id) => {
    if (libraryBooks.length < 2) {
      install(libraryBooks[0].id);
    } else {
      const items: ItemParam[] = libraryBooks.map((content) => {
        return {
          label: content.metaSubtitle,
          click: async () => {
            dialog.close();
            install(content.id);
          },
        };
      });
      dialog.open(DialogList, {
        level: DialogLevel.Info,
        title: t('library.subscriber.popin.add.title'),
        items,
        cancel: false,
        confirm: false,
        onCancel: () => dialog.close(),
      });
    }
  };

  const install = async (id: string) => {
    if (asMainContent) {
      await installAsMain(id);
    } else {
      await installAsAdded(id);
    }
  };

  const installAsMain = async (id: string) => {
    await libraryBooksSetAsMainContent.run(id);
  };

  const installAsAdded = async (id: string) => {
    try {
      loading.value = true;
      const added = await useLibraryBooksAddToProfile([id]);
      loading.value = false;
      if (added) {
        if (autoRedirect) {
          navigateTo(getContentPathFromId(id));
        } else {
          dialog.open(DialogInfo, {
            level: DialogLevel.Info,
            iconHeader: 'popinOpenContent',
            title: t('common.nomadPlus'),
            label: t('library.subscriber.popin.added'),
            cancel: true,
            onCancel: () => {
              dialog.close();
            },
            onConfirm: () => {
              dialog.close();
              navigateTo(getContentPathFromId(id));
            },
          });
        }
      } else {
        dialog.open(DialogError, {
          level: DialogLevel.Info,
          iconHeader: 'warning',
          label: t('error.request'),
        });
      }
    } catch (e) {
      globalThis.$logger.warn('error', e);
    }
  };

  return {
    select,
    install,
    loading,
  };
};
